import aes256 from 'aes256'

export default hash => aes256.decrypt(process.env.SLIP_URL_ENCRYPT_KEY, hash)


// WEBPACK FOOTER //
// ./src/services/getSlipUrl.js